"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SentryCore = require("@sentry/browser");
const state_1 = require("@airstudio/state");
class Sentry extends state_1.Extensions.Abstract {
    constructor() {
        super();
        this.key = 'sentry';
        state_1.Bus.onConfigReady(({ sentry }) => {
            if (!sentry) {
                // tslint:disable-next-line: no-console
                return console.warn('Sentry extension is activated but backend config did not provide a `sentry` value');
            }
            SentryCore.init(sentry);
            this.dispatchSuccess({
                sdkName: SentryCore.SDK_NAME,
                sdkVersion: SentryCore.SDK_VERSION,
            });
        });
        state_1.Bus.onUserReady(({ userId }) => {
            SentryCore.setUser({ userId });
        });
    }
}
exports.Sentry = Sentry;
//# sourceMappingURL=index.js.map